enum FeatureFlag {
  BETA_PLATFORM = "beta-platform",
  FIELDS_INSTRUCTION_HTML = "fields-instruction-html",
  MULTIPLE_PHOTOS = "multiple-photos",
}

export default FeatureFlag;
